import { useEffect, useState } from 'react';
import {
  useGetAttributeNodesMutation,
  useGetStandardNodesMutation,
  useGetTagNodesMutation,
  useGetTopicNodesMutation
} from '../../../features/authentication/qSetApiSlice';
import { Row } from 'react-bootstrap';
import TreeAdvanced from './TreeAdvanced';
import { useMyContentContext } from '../utils/myContentContext';
import SkeletonGrid from '../../../../src/components/SkeletonLoader/SkeletonGrid';

const AddQuestionProperties = () => {
  const { selectedTagNodes, setSelectedTagNodes, selectedAttributeNodes, setSelectedAttributeNodes,
    selectedStandardNodes, setSelectedStandardNodes, selectedTopicNodes, setSelectedTopicNodes } = useMyContentContext();

  const [attributeNodes, setAttributeNodes] = useState([]);
  const [attributeNodesCount, setAttributeNodeCount] = useState(0);
  const [attributeSearchText, setAttributeSearchText] = useState('');

  const [tagNodes, setTagNodes] = useState([]);
  const [tagNodesCount, setTagNodeCount] = useState(0);
  const [tagSearchText, setTagSearchText] = useState('');

  const [standardNodes, setStandardNodes] = useState([]);
  const [standardNodesCount, setStandardNodeCount] = useState(0);
  const [standardSearchText, setStandardSearchText] = useState('');

  const [topicNodes, setTopicNodes] = useState([]);
  const [topicNodesCount, setTopicNodeCount] = useState(0);
  const [topicSearchText, setTopicSearchText] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [getTagNodes] = useGetTagNodesMutation();
  const [getAttributeNodes] = useGetAttributeNodesMutation();
  const [getStandardNodes] = useGetStandardNodesMutation();
  const [getTopicNodes] = useGetTopicNodesMutation();

  useEffect(() => {
    setIsLoading(true);
    topicTreeHandler('', 'root');
    tagTreeHandler('', 'root');
    attributeTreeHandler('', 'root');
    standardTreeHandler('', 'root');
    setIsLoading(false);
  }, []);

  const setTreeNodes = async (response, nodeValue, rootName, nodes, setNodes, setNodeCount) => {
    try {
      if (nodeValue == 'root') {
        setNodes(response);
        setNodeCount(response.length);
      } else {
        const newIds = response.map((newItem) => newItem.id);
        if (
          !nodes
            .find((i) => i.name == rootName)
            .childrens.some((item2) => item2.id == newIds[0])
        )
          setNodes((prevData) => {
            return prevData.map((item) => {
              if (item.name === rootName) {
                const updatedChildrens = item.childrens.map((child) => {
                  if (child.id == nodeValue) {
                    return { ...child, children: newIds };
                  }
                  return child;
                });
                return { ...item, childrens: [...updatedChildrens, ...response] };
              }
              return item;
            });
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const topicTreeHandler = async (rootName, nodeValue, isChildAvailable, childrens) => {
    let response = [];
    if (isChildAvailable)
      response = childrens;
    else {
      let option = { node: nodeValue };
      response = await getTopicNodes(option).unwrap();
    }
    setTreeNodes(response, nodeValue, rootName, topicNodes, setTopicNodes, setTopicNodeCount);
  };

  const tagTreeHandler = async (rootName, nodeValue) => {
    let option = { node: nodeValue };
    const response = await getTagNodes(option).unwrap();
    setTreeNodes(response, nodeValue, rootName, tagNodes, setTagNodes, setTagNodeCount);
  };

  const attributeTreeHandler = async (rootName, nodeValue) => {
    let option = { node: nodeValue };
    const response = await getAttributeNodes(option).unwrap();
    setTreeNodes(response, nodeValue, rootName, attributeNodes, setAttributeNodes, setAttributeNodeCount);
  };

  const standardTreeHandler = async (rootName, nodeValue, isChildAvailable, childrens) => {
    let response = [];
    if (isChildAvailable)
      response = childrens;
    else {
      let option = { node: nodeValue };
      response = await getStandardNodes(option).unwrap();
    }
    setTreeNodes(response, nodeValue, rootName, standardNodes, setStandardNodes, setStandardNodeCount);
  };

  return (
    <div className='white-card p-3'>
      {!isLoading ? (
        <Row className="justify-content-between p-2 gap-4">
          <TreeAdvanced
            title='Topics'
            nodes={topicNodes}
            nodesCount={topicNodesCount}
            selectedAllNodes={selectedTopicNodes}
            setSelectedAllNodes={setSelectedTopicNodes}
            searchText={topicSearchText}
            setSearchText={setTopicSearchText}
            treeHandler={topicTreeHandler}
          />
          <TreeAdvanced
            title='Tags'
            nodes={tagNodes}
            nodesCount={tagNodesCount}
            selectedAllNodes={selectedTagNodes}
            setSelectedAllNodes={setSelectedTagNodes}
            searchText={tagSearchText}
            setSearchText={setTagSearchText}
            treeHandler={tagTreeHandler}
          />
          <TreeAdvanced
            title='Attributes'
            nodes={attributeNodes}
            nodesCount={attributeNodesCount}
            selectedAllNodes={selectedAttributeNodes}
            setSelectedAllNodes={setSelectedAttributeNodes}
            searchText={attributeSearchText}
            setSearchText={setAttributeSearchText}
            treeHandler={attributeTreeHandler}
          />
          <TreeAdvanced
            title='Standards'
            nodes={standardNodes}
            nodesCount={standardNodesCount}
            selectedAllNodes={selectedStandardNodes}
            setSelectedAllNodes={setSelectedStandardNodes}
            searchText={standardSearchText}
            setSearchText={setStandardSearchText}
            treeHandler={standardTreeHandler}
          />
        </Row>
      ):(
        <SkeletonGrid
          rowCount={1}
          colCount={4}
          className='p-5'/>
      )}
      
    </div>
  );
};

export default AddQuestionProperties;
